import { useTranslation } from "react-i18next"
import { CanSendHealthData } from "app/PermissionChecker"
import HomeWidgetLayout from "components/layout/HomeWidgetLayout"
import { useSelector } from "react-redux"
import { selectCompanyGuid, selectCurrentUserGuid } from "features/auth/authSlice"
import { useEffect } from "react"
import { useLazyGetCurrentUserHealthStatusQuery } from "../dashboard/api/healthStatusApiSlice"
import TopicSubscriber from "app/ws/TopicSubriber"
import { NavLink } from "react-router-dom"
import { BpmStatus } from "../dashboard/views/BpmStatus"
import { relativeTime } from "utility/TimeUtility"

function MyHealthWidget() {

    const [t, i18n] = useTranslation(["absenceReport"])

    const companyGuid = useSelector(selectCompanyGuid)
    const userGuid = useSelector(selectCurrentUserGuid)

    const [getStatus, {
        data: statuses,
        isLoading: statusesIsLoading,
        isSuccess: statusesIsSuccess,
        isError
    }] = useLazyGetCurrentUserHealthStatusQuery();


    useEffect(() => {
        getStatus()
    }, [])


    function handlePayload() {
        getStatus()
    }

    return <HomeWidgetLayout
        title={"My Health"}
        isLoading={statusesIsLoading}
        permission={CanSendHealthData}
        content={
            <>
                {statusesIsSuccess &&
                    <HealthRealtTimeCard
                        healthData={statuses}
                        onAction={() => { }}
                    />
                }
                {
                    isError &&
                    <span>Nessun dato disponibile.</span>
                }
                <button className="btn btn-success mt-2" type="button">
                    <NavLink to={{ pathname: "/dashboard/health/history/my" }} className="nav-link"><i className="fa-solid fa-chart-simple"></i> {t("health:menu.data_ext")}</NavLink>
                </button>
                <TopicSubscriber
                    subTopic={`company/${companyGuid}/health/${userGuid}`}
                    onMessageReceived={handlePayload}
                />
            </>
        }
    />
}

export default MyHealthWidget


const HealthRealtTimeCard = (
    {
        healthData,
        onAction = (userGuid, actionType) => { }
    }
) => {

    const MAX_DATA_AGE_SECONDS = 5 * 60 * 60; // 5 ore
    const RADIUS = 16 //px
    const BMP_WARNING_GAP = 5

    const [t] = useTranslation(["global"])
    const { user, hr, isOffBody, lastUpdate, minHr, maxHr } = healthData

    var delta = (Date.now() - lastUpdate * 1000)

    let veryHight = maxHr || 200;
    let hight = veryHight - BMP_WARNING_GAP;

    let veryLow = minHr || 20;
    let low = veryLow + BMP_WARNING_GAP;

    const status = calculateBpmStatus();
    const alpha = calculateAlpha();
    const color = bpmColor(status, alpha);


    function getSafeRangeColor() {

        if (hr == null || delta > 3600 * 1000 * 5) {
            return "bg-dark bg-opacity-25";
        }
        if (hr > low && hr < hight) {
            return "bg-dark bg-opacity-0";
        } else if ((hr >= hight && hr < veryHight) || (hr <= low && hr > veryLow)) {
            return "bg-warning bg-opacity-25";
        } else {
            return "bg-danger bg-opacity-25";
        }
    }

    function calculateAlpha(
        nowSeconds = Math.floor(Date.now() / 1000)
    ) {
        const age = Math.max(0, nowSeconds - lastUpdate);

        return age >= MAX_DATA_AGE_SECONDS
            ? 0
            : 1 - age / MAX_DATA_AGE_SECONDS;
    }

    function calculateBpmStatus() {
        if (isOffBody === true) {
            return BpmStatus.OFF_BODY;
        }

        if (hr == null) {
            return BpmStatus.READING;
        }

        if (hr < veryLow || hr > veryHight) {
            return BpmStatus.DANGER;
        }

        if (hr <= low || hr >= hight) {
            return BpmStatus.WARNING;
        }

        return BpmStatus.NORMAL;
    }

    function bpmColor(status, alpha) {
        switch (status) {
            case BpmStatus.DANGER:
                return `rgba(220, 53, 69, ${alpha})`; // bootstrap danger

            case BpmStatus.WARNING:
                return `rgba(255, 193, 7, ${alpha})`; // bootstrap warning

            case BpmStatus.NORMAL:
                return `rgba(25, 135, 84, ${alpha})`; // bootstrap primary

            case BpmStatus.OFF_BODY:
                return `rgba(108, 117, 125, 0)`; // invisible

            case BpmStatus.READING:
                return `rgba(108, 117, 125, ${alpha})`; // bootstrap secondary

            default:
                return `rgba(0, 0, 0, ${alpha})`;
        }
    }


    function getHeartIcon() {
        if (hr == null) {
            return;
        }
        if (hr > low && hr < hight) {
            return <i className="fa-solid fa-heart fa-fade text-danger"></i>;
        } else if ((hr >= hight && hr < veryHight) || (hr <= low && hr > veryLow)) {
            return <i className="fa-solid fa-heart-circle-exclamation fa-beat text-warning"></i>;
        } else {
            return <i className="fa-solid fa-heart-circle-exclamation fa-beat text-danger"></i>;
        }
    }
    return <>


        <div className={`col text-center `} style={{ opacity: alpha }}>

            {
                status == BpmStatus.OFF_BODY &&
                <h5><i className="fa-solid fa-hand"></i> OffBody</h5>
            }

            {
                status == BpmStatus.READING &&
                <>
                    <div className="spinner-border hidden text-light" role="status"></div>
                </>
            }

            {
                status != BpmStatus.OFF_BODY && status != BpmStatus.READING &&
                <>
                    <span className={`h2 font-bold p-1`}>
                        {getHeartIcon()} {hr}
                    </span>
                    <small className="text-muted">bpm</small>
                </>
            }
        </div>
        <div className="mb-2">
            <small className="text-muted"> {relativeTime(lastUpdate)}</small>
        </div>



    </>

}